export default __webpack_public_path__ + "static/media/addCardIcon.a4fe69ce.svg";